import * as Sentry from "@sentry/react";
import '@fortawesome/fontawesome-free/css/all.min.css';
import store, { persistor } from 'common/redux/store';
import AntdThemeConfigProvider from 'Provider/AntdThemeConfigProvider';
import 'react-confirm-alert/src/react-confirm-alert.css';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import "./i18n.ts"
import './index.scss';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
  release: process.env.REACT_APP_SENTRY_RELEASE,
  dataCollection: {
    // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#dataCollection
    // userInfo: false,
    // httpBodies: []
  }
});

const ErrorFallback = ({ resetError }: { resetError: () => void }) => (
  <div style={{ padding: 24, textAlign: 'center', fontFamily: 'sans-serif' }}>
    <h1>Something went wrong</h1>
    <p>An unexpected error occurred. Please try again.</p>
    <button
      onClick={resetError}
      style={{ padding: '8px 16px', cursor: 'pointer' }}
    >
      Reload
    </button>
  </div>
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// const [isDark, setIsDark] = useState(false)

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
       <AntdThemeConfigProvider>
         <Sentry.ErrorBoundary fallback={ErrorFallback}>
           <App />
         </Sentry.ErrorBoundary>
       </AntdThemeConfigProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>
  // </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// import '@fortawesome/fontawesome-free/css/all.min.css';
// import 'react-confirm-alert/src/react-confirm-alert.css';
// import './index.scss';

// import React, { useState } from 'react';
// import ReactDOM from 'react-dom/client';
// import { Provider } from 'react-redux';
// import { PersistGate } from 'redux-persist/integration/react';
// import { BrowserRouter } from 'react-router-dom';
// import { ConfigProvider, theme as antdTheme } from 'antd';

// import store, { persistor } from 'common/redux/store';
// import App from './App';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// const { darkAlgorithm, defaultAlgorithm } = antdTheme;

// const RootApp = () => {
//   const [isDark, setIsDark] = useState(false);

//   const theme = {
//     algorithm: isDark ? darkAlgorithm : defaultAlgorithm,
//     token: {
//       colorPrimary: '#947df0',
//       colorLink: '#947df0',
//     },
//   };

//   return (
//     <Provider store={store}>
//       <PersistGate loading={null} persistor={persistor}>
//         <BrowserRouter>
//           <ConfigProvider theme={theme}>
//             <App />
//           </ConfigProvider>
//         </BrowserRouter>
//       </PersistGate>
//     </Provider>
//   );
// };

// const root = ReactDOM.createRoot(
//   document.getElementById('root') as HTMLElement
// );
// root.render(<RootApp />);

// // Optional: enable service worker
// serviceWorkerRegistration.register();
